module.exports = __webpack_public_path__ + "img/1F910.28f92f53.svg";